import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast";
import axios from "../../API/axios";
// import { post } from '../../config/imagesLink'
import { motion } from "framer-motion";
import Comment from "./Comment"; 
import CommentAction from "./CommentAction";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { Col, Modal, Row } from "react-bootstrap";

import PublicSharpIcon from "@mui/icons-material/PublicSharp";
import GroupSharpIcon from "@mui/icons-material/GroupSharp";
import LockSharpIcon from "@mui/icons-material/LockSharp";
import TuneSharpIcon from "@mui/icons-material/TuneSharp";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import SingleComment from "./SingleComment";
import { post } from "../../config/imagesLink";
import ModalForGuest from "../ModalForGuest";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import BookmarkOutlinedIcon from "@mui/icons-material/BookmarkOutlined";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
// import { Select } from "antd";
import Select from "react-select";
import ReactQuill from "react-quill";
import PostComponent from "./PostComponent";
import { customStyles } from "../../selectStyles";
import moment from "moment";
import { useTranslation } from "react-i18next";

const { like, celebrate, support, love, insightful, funny, likegif } = post;

const SinglePostEngagement = ({
  isOwnedPost,
  postId,
  AllPostComments,
  AllPostList,
  updateCommentCount,
  singlepostList,
  setSinglePostListInfo,
  singlepostListinfo,
  setSinglePostList,
  setPostList,
  item,
  AllPostData,
  singlepostCommentList,
  setSinglePostCommentList,
  updatePostLike,
  postList,
  setIsLiked,
  isLiked,
  // setPage,
  // page,
  // setTotalPages,
  // totalPages,
  // setDLike,
  // updateLikeCount,
  // updateShareCount,
  openModal,
  setSinglePostId,
  setSinglePostContent,
  updateCommentLike,
  // setSinglePostId,
  setIspostmodalOpen,
  ispostmodalOpen,
  setDLike,
  updateLikeCount,
  updateReplyCommentLike,
}) => {

  console.log("engagement0000000000000", singlepostListinfo);
  const [showComments, setShowComments] = useState(false);
  const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");
  const { t } = useTranslation();

  const guestModeData = localStorage.getItem("guestMode");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const getApiErrorMessage = (error) => {
    return (
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong. Please try again."
    );
  };

  const editorRef = useRef(null);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionType, setMentionType] = useState("");
  const [SearchText, setSearchText] = useState("")
  const language = localStorage.getItem("Lang");

  const toggleComments = () => {
    setShowComments(!showComments);
  };
  // console.log(showComments);

  // console.log('item', item);
  const sessionId = localStorage.getItem("sessionId");
  //************************Save Post start  ************************//
  const [isSaved, setIsSaved] = useState(false);
  const savePost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
            langKey: language === "en" ? "" : language,

    };
    try {
      const res = await axios.post(`PostAction/SavePost`, responseData);
      // .then((res) => {
      console.log("save post", res);
      // toast.success(res.data.message);
      setToastMessage(res.data.message);
      setShowToast(true);
      setIsSaved(true);

      // -------------------------------------------
      setPostList((prevPosts) =>
        prevPosts.map((post) =>
          post.postInfo.postId === postId
            ? {
              ...post,
              postInfo: {
                ...post.postInfo,
                postActionsInfo: {
                  ...post.postInfo.postActionsInfo,
                  isSaved: true,
                },
              },
            }
            : post
        )
      );

      setSinglePostContent((prev) => ({
        ...prev,
        postInfo: {
          ...prev.postInfo,
          postActionsInfo: {
            ...prev.postInfo.postActionsInfo,
            isSaved: true,
          },
        },
      }));
      // -------------------------------------------
   
    } catch (e) {
      const errorMessage = getApiErrorMessage(e);
      if (e?.response && e.response.status === 404) {
        setWarningToastMessage(errorMessage);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
    }
  };

  //************************Save Post End  ************************//

  //************************UnSave Post start  ************************//
  const unsavePost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
            langKey: language === "en" ? "" : language,

    };
    try {
      const res = await axios.post(`PostAction/UnsavePost`, responseData);
      // .then((res) => {
      // console.log(res);
      // toast.success(res.data.message);
      setToastMessage(res.data.message);
      setShowToast(true);
      setIsSaved(false);
      // -------------------------------------------
      setPostList((prevPosts) =>
        prevPosts.map((post) =>
          post.postInfo.postId === postId
            ? {
              ...post,
              postInfo: {
                ...post.postInfo,
                postActionsInfo: {
                  ...post.postInfo.postActionsInfo,
                  isSaved: false,
                },
              },
            }
            : post
        )
      );

      setSinglePostContent((prev) => ({
        ...prev,
        postInfo: {
          ...prev.postInfo,
          postActionsInfo: {
            ...prev.postInfo.postActionsInfo,
            isSaved: false,
          },
        },
      }));
      // -------------------------------------------
      // AllPostList();
      // const postDetailsResponse = await axios.get(
      //   `/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}&RestrictedViewerToken=${restrictedViewerToken}`
      // );
      // console.log("postDetailsResponse", postDetailsResponse);
      // const updatedPost = postDetailsResponse.data.responseData;
      // console.log("updatedPost", updatedPost);

      // // Update the existing post in the list
      // setPostList((prev) =>
      //   prev.map((post) =>
      //     post.postId === updatedPost.postId ? updatedPost : post
      //   )
      // );
      // });
    } catch (e) {
      const errorMessage = getApiErrorMessage(e);
      if (e?.response && e.response.status === 404) {
        setWarningToastMessage(errorMessage);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
    }
  };

  //************************UnSave Post End  ************************//

  //************************like Post start  ************************//
  const [selectedImg, setSelectedImage] = useState("");
  const [isLiking, setIsLiking] = useState(false);
  // const [isLiked, setIsLiked] = useState(false);
  const [likedType, setLikedType] = useState(null);
  const [changeLikedType, setChangeLikedType] = useState(null);

  const applyPostLikeUpdate = (delta, isLikedStatus, nextLikedType) => {
    if (typeof updatePostLike !== "function") return;

    if (updatePostLike.length >= 4) {
      updatePostLike(postId, delta, isLikedStatus, nextLikedType);
      return;
    }

    updatePostLike(postId, isLikedStatus, nextLikedType);
  };

  const LikePost = async (liketype, imageName) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
      likeType: liketype,
            langKey: language === "en" ? "" : language,

    };
    // console.log(responseData);
    setIsLiking(true);
    setLikedType(liketype);
    setTimeout(async () => {
      try {
        const res = await axios.post("PostAction/LikePost", responseData);
        setToastMessage(res?.data.message);
        setShowToast(true);
        // updatePostLike(postId, 1, true, liketype);
        // AllPostList();
        if (typeof AllPostData === "function") {
          AllPostData();
        } else if (typeof AllPostList === "function") {
          AllPostList();
        }
        setSelectedImage(imageName);
        setIsHovered(false);
        setIsLiking(false);
        setIsLiked(true);
        setLikedType(liketype); 
        updateLikeCount(postId, 1, true, liketype);

      } catch (e) {
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response?.data?.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response?.data?.message);
          setShowErrorToast(true);
        }
      }
    }, 1000);
  };

  //************************like Post End  ************************//
  //************************Relike Post End  ************************//
  const ReLikePost = async (liketype, imageName) => {
    try {
      const currentLikedType =
        likedType ??
        changeLikedType ??
        singlepostList?.postInfo?.postInfo?.postActionsInfo?.likedType;

      if (Number(currentLikedType) === Number(liketype)) {
        setIsHoveredRelike(false);
        return;
      }

      const responseData = {
        deviceType: "Web",
        sessionId: sessionId,
        postId: postId,
        likeType: liketype,
        langKey: language === "en" ? "" : language,
      };
      
      console.log("ReLikePost payload:", responseData);
      setIsLiking(true);
      setLikedType(liketype);

      const res = await axios.post("/PostAction/ChangeLikeType", responseData);
      
      setToastMessage(res?.data.message);
      setShowToast(true);
      applyPostLikeUpdate(0, true, liketype);
      setSelectedImage(imageName);
      setIsHovered(false);
      setIsLiking(false);
      setIsLiked(true);
      setLikedType(liketype);
      setChangeLikedType(liketype);

      // Fetch the full post details in a separate try-catch to ensure it runs
      try {
        // const isVideoContent = 
        //   singlepostListinfo?.postInfo?.postCategory === "Video" || 
        //   singlepostListinfo?.postInfo?.postCategory === "TextWithVideo" ||
        //   singlepostListinfo?.postInfo?.sharedPost?.postCategory === "Video" ||
        //   singlepostListinfo?.postInfo?.sharedPost?.postCategory === "TextWithVideo";

        // const tokenParam = isVideoContent 
        //   ? `&RestrictedViewerToken=${restrictedViewerToken || ''}` 
        //   : '&RestrictedViewerToken=null';
        
        // const langParam = language === "en" ? "" : language;
        
        // console.log("Fetching post details - isVideoContent:", isVideoContent, "tokenParam:", tokenParam);
        
        const postDetailsResponse = await axios.get(
          // `/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}${tokenParam}&langKey=${langParam}`
          `/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}&RestrictedViewerToken=${restrictedViewerToken || ''}&langKey=${language === "en" ? "" : language}`
        );
        const updatedPost = postDetailsResponse?.data?.responseData;
        console.log("updatedPost", updatedPost);

        // Update the existing post in the list
        if (updatedPost) {
          setSinglePostList(updatedPost);
        }
      } catch (postError) {
        console.error("Error fetching post details:", postError);
        // Don't show error to user as the like action was successful
      }
      
    } catch (e) {
      console.log("ReLikePost error:", e);
      setIsLiking(false);
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response?.data?.message);
        setShowWarningToast(true);
      } else if (e.response && e.response.status === 400) {
        setErrorToastMessage(e.response?.data?.message || "Bad request. Please try again.");
        setShowErrorToast(true);
      } else {
        setErrorToastMessage(e.response?.data?.message || "An error occurred");
        setShowErrorToast(true);
      }
    }
  };

  //************************Relike Post End  ************************//
  //************************unlike Post start  ************************//
  const UnLikePost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
            langKey: language === "en" ? "" : language,

    };
    // console.log(responseData);
    try {
      const res = await axios.post(`PostAction/UnlikePost`, responseData);
      //  .then((res) => {
      // console.log(res);
      // toast.success(res.data.message);
      setToastMessage(res.data.message);
      setShowToast(true);
      AllPostList();
      applyPostLikeUpdate(-1, false, null);
      setIsHovered(false);
      setIsLiked(false);
      // setDLike(-1)
      updateLikeCount(postId, -1, false, null);
      setLikedType(null);
     } catch (e) {
      const errorMessage = getApiErrorMessage(e);
      if (e?.response && e.response.status === 404) {
        setWarningToastMessage(errorMessage);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
    }
  };
  console.log("singlepostList111111", singlepostList);


  //************************unlike Post End  ************************//
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredRelike, setIsHoveredRelike] = useState(false);
  const list = {
    visible: {
      opacity: 1,
    },
    hidden: {
      opacity: 0,
    },
  };

  const [shareModal, setShareModal] = useState(false);
  const [shareUrl, setShareUrl] = useState();
  const sharePost = async () => {
    const sharePost = {
      deviceType: "Web",
      id: postId,
      type: 1,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post("SMFeatures/SaveShareURL", sharePost).then((res) => {
        console.log("share", res);
        setShareUrl(res.data.responseData.value);
        // updateShareCount(postId, 1)
      });
    } catch (error) {
      console.log(error);
    }
  };

  const [emojiList, setemojiList] = useState();
  // console.log('emojiList', emojiList);
  const GetEmoji = async () => {
    try {
      await axios.get(`Master/GetEmojiDDL?LangKey=${language}`).then((res) => {
        // console.log("share", res);
        setemojiList(res.data.responseData);
        // updateShareCount(postId, 1);
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetEmoji();
  }, []);

  useEffect(() => {
    if (shareModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [shareModal]);

  const [followModal, setFollowModal] = useState(false);
  const closeModalData = () => {
    setFollowModal(false);
  };


  //Post create logic 

  const [initialSlideIndex, setInitialSlideIndex] = useState(0);
  const [imageArray, setImageArray] = useState([]);

  const [privacyType, setPrivacyType] = useState(t("Public"));
  const Privacy = [
    // { value: "Public", label: "Public", icon: <PublicSharpIcon /> },
    // { value: "Friends", label: "Friends", icon: <GroupSharpIcon /> },
    // { value: "OnlyMe", label: "OnlyMe" , icon: <LockSharpIcon /> },
    // { value: "Custom", label: "Custom" , icon: <TuneSharpIcon /> },
    { value: "Public", label: t("Newsfeed.Public") , icon: <PublicSharpIcon /> },
    { value: "Friends", label: t("Newsfeed.Friends") , icon: <GroupSharpIcon /> },
    { value: "OnlyMe", label: t("Newsfeed.OnlyMe"), icon: <LockSharpIcon /> },
    { value: "Custom", label: t("Newsfeed.Custom") , icon: <TuneSharpIcon /> },
  ];
  const [postContent, setPostContent] = useState("");
  const [postID, setPostID] = useState("");
  const [display, setDisplay] = useState(false);
  const [isloading, setIsloading] = useState(false);

  const [cursorPosition, setCursorPosition] = useState(0);
  const [query, setQuery] = useState("");
  const [postInputValue, setPostInputValue] = useState("");
  const [postDynamicValues, setPostDynamicValues] = useState([]);
  const userUid = localStorage.getItem("userUid");

  const handleChange = (content, delta, source, editor) => {
    const value = editor.getText(); // plain text, better than content HTML
    const caret = editor.getSelection()?.index || 0;

    setPostContent(content); // still keep full HTML
    setCursorPosition(caret);
    detectTrigger(value, caret);

    // Filter out dynamic values no longer in content
    const updatedDynamicValues = postDynamicValues?.filter(
      ({ type, display }) => {
        const prefix = type === "UserMention" ? "@" : "#";
        const fullMention = `${prefix}${display}`;
        return value.includes(fullMention);
      }
    );

    // Reassign dVno after filtering to keep {1}, {2}, ... in correct order
    const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
      ...item,
      dVno: index + 1,
    }));

    setPostDynamicValues(reassignedDynamicValues);

    // Recompute postInputValue
    const quillInstance = editorRef.current?.getEditor?.();
    const htmlContent = quillInstance?.root?.innerHTML || "";

    const updatedPostInputValue = updatePostInputValueWithDynamicValues(
      htmlContent,
      reassignedDynamicValues
    );

    setPostInputValue(updatedPostInputValue);
  };

  const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
    let modifiedText = rawContent;

    dynamicValues.forEach(({ type, dVno, display }) => {
      const prefix = type === "UserMention" ? "@" : "#";
      const fullMention = `${prefix}${display}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    return modifiedText.trim();
  };

  // Detect @ or #
  const detectTrigger = (value, caret) => {
    const textBeforeCursor = value?.slice(0, caret);
    const match = textBeforeCursor.match(/([@#])(\w*)$/);
    if (match) {
      const trigger = match[1];
      const q = match[2];
      setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
      setQuery(q);
      fetchSuggestions(q, trigger);
      setSearchText(q)
    } else {
      // setShowSuggestions(false);
      setSearchText('')
    }
  };

  const fetchSuggestions = async (searchText, triggerChar) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };

    try {
      if (triggerChar === "@") {
        const res = await axios.post(
          `General/MentionTagDDL?Search=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      } else if (triggerChar === "#") {
        const res = await axios.post(
          `General/HashtagDDL?SearchHashtag=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      }
    } catch (err) {
      console.error(err);
      if (triggerChar === "#" && searchText) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }
  };

  const insertMention = (suggestion, userUid) => {
    const quill = editorRef.current?.getEditor?.();
    if (!quill) return;

    const cursorPosition = quill.getSelection()?.index || 0;
    const textBeforeCursor = quill.getText(0, cursorPosition);
    const match = textBeforeCursor.match(/[@#]\w*$/);
    if (!match) return;

    const startIndex = cursorPosition - match[0].length;
    const mentionPrefix = mentionType === "UserMention" ? "@" : "#";
    const displayName = suggestion;
    const mentionText = `${mentionPrefix}${displayName} `;

    // Replace partial mention with full one
    quill.deleteText(startIndex, match[0].length);
    quill.insertText(startIndex, mentionText);
    quill.setSelection(startIndex + mentionText.length);

    // Update dynamic values
    const safePostDynamicValues = Array.isArray(postDynamicValues)
      ? postDynamicValues
      : [];
    const dVno = safePostDynamicValues.length + 1;

    const updatedPostDynamicValues = [
      ...safePostDynamicValues,
      {
        type: mentionType,
        dVno,
        entity: mentionType === "UserMention" ? userUid : suggestion,
        display: displayName,
      },
    ];
    setPostDynamicValues(updatedPostDynamicValues);

    const editorHtml = quill.root.innerHTML;
    const updatedInputValue = updatePostInputValueWithDynamicValues(
      editorHtml,
      updatedPostDynamicValues
    );
    setPostInputValue(updatedInputValue);
    setShowSuggestions(false);
    setSearchText('')
  };

  // Helper: Escape regex special characters
  const escapeRegex = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const handleSubmit = async () => {
    setIsloading(true);
    try {
      setDisplay(true);
      const payload = {
        DeviceType: "Web",
        sessionId: sessionId,
        PrivacyType: privacyType || "Public",
        PostOriginType: "User",
        originPostId: postId,
        PostOriginID: userUid,
        PostCategory: "SharePost",
        PostContent: postInputValue ? postInputValue : postContent,
        DynamicValues: postDynamicValues,
              langKey: language === "en" ? "" : language,

      };
      const res = await axios.post("/Posts/SharePost", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setToastMessage(res?.data?.message || "Post Shared Successfully");
      setShowToast(true);
      setShareModal(false);
      AllPostList();
      setPostDynamicValues([]);
      setPostInputValue("");
      const newPostId = res?.data?.responseData?.id;
      
      const postDetailsResponse = await axios.post(
        `/Posts/GetPostInfo?DeviceType=Web&PostId=${newPostId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`
      );
      const newPost = postDetailsResponse?.data?.responseData;
      setPostList((prev) => [newPost, ...prev]);
      setPostContent("");
      // setImages([])D;
      setPostID("");
      // setShowSecondModal(false);
      setIsloading(false);
      setPostDynamicValues([]);
      setPostInputValue("");
    } catch (error) {
      console.log("newPostId", error);
      const errorMessage = getApiErrorMessage(error);
      if (error?.response && error.response.status === 404) {
        setWarningToastMessage(errorMessage);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
      setIsloading(false);
    }
  };


  return (
    <>
      <div className="bordertop-custom pt-2 pb-3 Post-Action-Content">
        {/* 1 */}
        {/* <div className="Post-Action-section"> */}
        <div className="d-flex align-items-center postAction likeActions ">
          {/* {console.log("changeLikedType", isLiked, likedType, changeLikedType)} */}

          {isLiked === true ||
            singlepostList?.postInfo?.postInfo?.postActionsInfo?.isLiked === true ? (
            <motion.div
              className="like-container pointer d-flex align-items-center"
              onClick={() => UnLikePost()}
              whileHover={{ scale: 1.3 }}
              onMouseEnter={() => setIsHoveredRelike(true)}
              onMouseLeave={() => setIsHoveredRelike(false)}
            >
              {singlepostList?.postInfo?.postInfo?.postActionsInfo?.likedType === 1 ||
                likedType === 1 ||
                changeLikedType === 1 ? (
                <>
                  <img src={post.LikeGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                </>
              ) : singlepostList?.postInfo?.postInfo?.postActionsInfo?.likedType === 2 ||
                likedType === 2 ||
                changeLikedType === 2 ? (
                <>
                  <img src={post.LoveGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Love")}</p>
                </>
              ) : singlepostList?.postInfo?.postInfo?.postActionsInfo?.likedType === 3 ||
                likedType === 3 ||
                changeLikedType === 3 ? (
                <>
                  <img src={post.LaughingGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Laugh")}</p>
                </>
              ) : singlepostList?.postInfo?.postInfo?.postActionsInfo?.likedType === 4 ||
                likedType === 4 ||
                changeLikedType === 4 ? (
                <>
                  <img src={post.WowGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Wow")}</p>
                </>
              ) : singlepostList?.postInfo?.postInfo?.postActionsInfo?.likedType === 5 ||
                likedType === 5 ||
                changeLikedType === 5 ? (
                <>
                  <img src={post.AngryGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Angry")}</p>
                </>
              ) : (
                <>
                  <img src={post.LikeGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                </>
              )}
            </motion.div>
          ) : isLiking ? (
            (console.log("likedType", likedType),
              likedType === 1 ? (
                <>
                  {/* <img src={post.LikeGif} width={30} /> */}
                  <img src={likegif} alt="loading" width={50} />
                  <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                </>
              ) : likedType === 2 ? (
                <>
                  <img src={post.LoveGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Love")}</p>
                </>
              ) : likedType === 3 ? (
                <>
                  <img src={post.LaughingGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Laugh")}</p>
                </>
              ) : likedType === 4 ? (
                <>
                  <img src={post.WowGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Wow")}</p>
                </>
              ) : likedType === 5 ? (
                <>
                  <img src={post.AngryGif} width={25} />
                  <p className="f-12 ms-1">{t("Newsfeed.Angry")}</p>
                </>
              ) : (
                <>
                  {/* <img src={post.LikeGif} width={30} /> */}
                  <img src={likegif} alt="loading" width={50} />
                  <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                </>
              ))
          ) : (
            <>
              {guestModeData === "true" ? (
                <div className="d-flex align-items-center">
                  <motion.span
                    className="material-symbols-sharp pointer pe-1 "
                    onClick={() => {
                      setFollowModal(true);
                    }}
                  >
                    <ThumbUpAltOutlinedIcon />
                  </motion.span>
                  <p
                    className="f-12 pointer ms-1"
                    onClick={() => {
                      setFollowModal(true);
                    }}
                  >
                      {t("Newsfeed.Like")}
                  </p>
                </div>
              ) : (
                <div className="d-flex align-items-center">
                  <motion.span
                    whileHover={{ scale: 1.3 }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={() => {
                      LikePost(1, "Like");
                    }}
                    className="material-symbols-sharp pointer  pe-1"
                  >
                    <ThumbUpAltOutlinedIcon />
                  </motion.span>
                  <motion.p
                    className="f-12 pointer ms-1 mb-0"
                    whileHover={{ scale: 1.3 }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={() => {
                      LikePost(1, "Like");
                    }}
                  >
                    {t("Newsfeed.Like")}
                  </motion.p>
                </div>
              )}
            </>
          )}
          {isHovered && (
            <motion.div
              className="reactionsHolder"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              variants={list}
            >
              {emojiList?.map((item) => {
                return (
                  <div className="emoji-container" key={item.value}>
                    <motion.img
                      whileHover={{ scale: 1.5 }}
                      src={item.url}
                      alt=""
                      onClick={() => {
                        LikePost(item.value, item.name);
                      }}
                    />
                    <span className="emoji-name">{item.name}</span>
                  </div>
                );
              })}
            </motion.div>
          )}
          {isHoveredRelike && (
            <motion.div
              className="reactionsHolder"
              onMouseEnter={() => setIsHoveredRelike(true)}
              onMouseLeave={() => setIsHoveredRelike(false)}
              variants={list}
            >
              {emojiList?.map((item) => {
                return (
                  <div className="emoji-container" key={item.value}>
                    <motion.img
                      whileHover={{ scale: 1.5 }}
                      src={item.url}
                      alt=""
                      onClick={() => {
                        ReLikePost(item.value, item.name);
                      }}
                    />
                    <span className="emoji-name">{item.name}</span>
                  </div>
                );
              })}
            </motion.div>
          )}
        </div>

        {guestModeData === "true" ? (
          <div
            className="d-flex align-items-center postAction"
            onClick={() => {
              setFollowModal(true);
            }}
          >
            <ChatOutlinedIcon className="material-symbols-sharp pointer" />

            <p className="f-14 pointer ms-1">{t("Newsfeed.Comment")}</p>
          </div>
        ) : (
          <div
            className="d-flex align-items-center postAction"
          // onClick={() => {
          //   openModal(singlepostList?.mediaFilesList.map((file) => file.mediaName));
          //   setSinglePostContent(singlepostList);
          //   setIspostmodalOpen(true);
          //   setSinglePostId(singlepostList?.postId);
          // }}
          >
            <ChatOutlinedIcon className="material-symbols-sharp pointer" />
            <p className="f-14 pointer ms-1">{t("Newsfeed.Comment")}</p>
          </div>
        )}
        {/* </div> */}

        {/* 2 */}
        {/* <div  className="Post-Action-section"> */}
        {          guestModeData === "true" ? (
          <div className="d-flex align-items-center postAction">
          <ShareOutlinedIcon
            className="material-symbols-sharp pointer"
            onClick={(e) => {
              e.preventDefault();
              setShareModal(true);
              sharePost();
            }}
          />
          <p
            className="f-12 pointer ms-1"
            onClick={() => {
                setFollowModal(true);
              }}
          >
             {t("Newsfeed.Share")}
          </p>
        </div>

        ):(
<>
<div className="d-flex align-items-center postAction">
          <ShareOutlinedIcon
            className="material-symbols-sharp pointer"
            onClick={(e) => {
              e.preventDefault();
              setShareModal(true);
              sharePost();
            }}
          />
          <p
            className="f-12 pointer ms-1"
            onClick={(e) => {
              e.preventDefault();
              setShareModal(true);
              sharePost();
            }}
          >
             {t("Newsfeed.Share")}
          </p>
        </div></>
        )}
        

        {isSaved === true ||
          singlepostList?.postInfo?.postInfo?.postActionsInfo?.isSaved === true ? (
          <div className="d-flex align-items-center postAction">
            <BookmarkOutlinedIcon
              className="material-symbols-sharp pointer"
              onClick={() => {
                if (guestModeData !== "true") {
                  unsavePost();
                } else {
                  setFollowModal(true);
                }
              }}
              disabled={guestModeData === "true"}
            />
            <p
              className="f-12 pointer ms-1"
              onClick={() => {
                if (guestModeData !== "true") {
                  unsavePost();
                } else {
                  setFollowModal(true);
                }
              }}
            >
             {t("Newsfeed.Save")}
            </p>
          </div>
        ) : (
          <div className="d-flex align-items-center postAction">
            <BookmarkBorderOutlinedIcon
              className="material-symbols-outlined pointer"
              onClick={() => {
                if (guestModeData !== "true") {
                  savePost();
                } else {
                  setFollowModal(true);
                }
              }}
              disabled={guestModeData === "true"}
            />
            <p
              className="f-12 pointer ms-1"
              onClick={() => {
                if (guestModeData !== "true") {
                  savePost();
                } else {
                  setFollowModal(true);
                }
              }}
            >
               {t("Newsfeed.Save")}
            </p>
          </div>
        )}
        {/* </div> */}
      </div>

      {/* {ispostmodalOpen === undefined || ispostmodalOpen === true ? ( */}
      <SingleComment
        isOwnedPost={isOwnedPost}
        singlepostCommentList={singlepostCommentList}
        setSinglePostCommentList={setSinglePostCommentList}
        // item={item}
        singlepostListinfo={singlepostListinfo}
        setSinglePostListInfo={setSinglePostListInfo}
        updateCommentCount={updateCommentCount}
        postId={singlepostList?.postInfo?.postInfo?.postId}
        AllPostList={AllPostList}
        AllPostComments={AllPostComments}
        singlepostList={singlepostList}
        postList={postList}
        // setPage={setPage}
        setSinglePostList={setSinglePostList}
        emojiList={emojiList}
        setPostList={setPostList}
        updateCommentLike={updateCommentLike}
        updateLikeCount={updateLikeCount}
        updateReplyCommentLike={updateReplyCommentLike}
      // page={page}
      // setTotalPages={setTotalPages}
      // totalPages={totalPages}
      />


      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {/* <Modal
        show={shareModal}
        onHide={() => setShareModal(false)}
        size="xl"
        centered
        toggle={() => setShareModal(!shareModal)}
      >
        <Modal.Header
          closeButton
          className="bg-transparent p-2 border-bottom"
          toggle={() => setShareModal(!shareModal)}
        >
          <h5 className="main-heading">Share Job</h5>
        </Modal.Header>
        <Modal.Body className="text-center ">
          <FacebookShareButton
            url={shareUrl}
            onClick={() => {
              setShareModal(false);
            }}
          >
            <FacebookIcon size={40} />
          </FacebookShareButton>
          <WhatsappShareButton
            url={shareUrl}
            className="ms-2"
            onClick={() => {
              setShareModal(false);
            }}
          >
            <WhatsappIcon size={40} />
          </WhatsappShareButton>
          <LinkedinShareButton
            url={shareUrl}
            className="ms-2"
            onClick={() => {
              setShareModal(false);
            }}
          >
            <LinkedinIcon size={40} />
          </LinkedinShareButton>
          <TwitterShareButton
            url={shareUrl}
            className="ms-2"
            onClick={() => {
              setShareModal(false);
            }}
          >
            <TwitterIcon size={40} />
          </TwitterShareButton>

          <Row>
            <Col
              className="mt-1 d-flex justify-content-between"
              xs={2}
              lg={2}
            ></Col>
            <Col
              className="mt-1 d-flex justify-content-between"
              xs={2}
              lg={2}
            ></Col>
          </Row>
        </Modal.Body>
      </Modal> */}

      {/* {shareModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>Share Post</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setShareModal(false);
                  }}
                />
              </div>

              <div className="mt-3">
                <FacebookShareButton
                  url={shareUrl}
                  onClick={() => {
                    setShareModal(false);
                  }}
                >
                  <FacebookIcon size={40} />
                </FacebookShareButton>
                <WhatsappShareButton
                  url={shareUrl}
                  className="ms-2"
                  onClick={() => {
                    setShareModal(false);
                  }}
                >
                  <WhatsappIcon size={40} />
                </WhatsappShareButton>
                <LinkedinShareButton
                  url={shareUrl}
                  className="ms-2"
                  onClick={() => {
                    setShareModal(false);
                  }}
                >
                  <LinkedinIcon size={40} />
                </LinkedinShareButton>
                <TwitterShareButton
                  url={shareUrl}
                  className="ms-2"
                  onClick={() => {
                    setShareModal(false);
                  }}
                >
                  <TwitterIcon size={40} />
                </TwitterShareButton>
                 
                <Row>
                  <Col
                    className="mt-1 d-flex justify-content-between"
                    xs={2}
                    lg={2}
                  ></Col>
                  <Col
                    className="mt-1 d-flex justify-content-between"
                    xs={2}
                    lg={2}
                  ></Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {shareModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex flex-column p-2">
              {/* Modal Header */}
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("Newsfeed.Share Post")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => setShareModal(false)}
                />
              </div>

              {/* Share Buttons */}
              <div className="my-4 d-flex justify-content-between px-4">
                <FacebookShareButton
                  url={shareUrl}
                  onClick={() => setShareModal(false)}
                >
                  <FacebookIcon className="ShareIcon" />
                </FacebookShareButton>
                <WhatsappShareButton
                  url={shareUrl}
                  className="ms-2"
                  onClick={() => setShareModal(false)}
                >
                  <WhatsappIcon className="ShareIcon" />
                </WhatsappShareButton>
                <LinkedinShareButton
                  url={shareUrl}
                  className="ms-2"
                  onClick={() => setShareModal(false)}
                >
                  <LinkedinIcon className="ShareIcon" />
                </LinkedinShareButton>
                {/* <TwitterShareButton
                  url={shareUrl}
                  className="ms-2"
                  onClick={() => setShareModal(false)}
                >
                  <TwitterIcon className="ShareIcon" />
                </TwitterShareButton> */}
                <TwitterShareButton
                                  url={shareUrl}
                                  className="ms-2"
                                  onClick={() => setShareModal(false)}
                                >
                                  <div className="ShareIcon d-flex align-items-center justify-content-center" style={{backgroundColor:"black"}}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                                      <path d="M18.244 2H21.5l-7.45 8.51L22 22h-6.828l-5.345-6.993L3.95 22H.692l7.97-9.104L2 2h7l4.83 6.338L18.244 2Zm-2.396 18h1.889L8.11 3.889H6.083L15.848 20Z"/>
                                    </svg>
                                  </div>
                                </TwitterShareButton>
              </div>

              <div
                className=" postAdd"
                tabIndex="-1"
                role="dialog"
                style={{ display: "block" }}
              >
                <div className=" " role="document">
                  <div className="modal-content d-flex justify-content-around">
                    <div className=" modalBorder d-flex justify-content-between align-items-center p-2">
                      <h6>{t("Newsfeed.Post Something on")}</h6>
                      {/* <input type="checkbox" />
                            My Timeline */}
                       <Select
                        defaultValue={Privacy.find(
                          (option) => option.value === privacyType
                        )}
                        onChange={(selectedOption) => {
                          setPrivacyType(selectedOption.value);
                        }}
                        options={Privacy}
                        placeholder={t("Newsfeed.Select Privacy")}
                        styles={customStyles}
                        formatOptionLabel={({ label, icon }) => (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {icon}
                            <span style={{ marginLeft: 8 }}>{label}</span>
                          </div>
                        )}
                      /> 
                    </div>
                    <div className="m-3">
                      <div className="post-editor-container">
                        <ReactQuill
                          ref={editorRef}
                          value={postContent}
                          onChange={(content, delta, source, editor) => {
                            handleChange(content, delta, source, editor);
                          }}
                          placeholder={t("Newsfeed.What do you want to talk about?")}

                          // placeholder="What do you want to talk about?"
                          modules={{ toolbar: false }}
                        />

                        {showSuggestions && (
                          <ul className="suggestion-box">
                            {mentionType === "Hashtag" ? <li
                              onMouseDown={(e) => {
                                e.preventDefault(); // Prevent editor blur
                                insertMention(
                                  SearchText,
                                  null
                                );
                              }}
                              className="suggestion-item"
                            >
                              <span>{SearchText ? `#${SearchText}` : ''}</span>
                            </li> : null}
                            {suggestions?.map((item, index) => (
                              <li
                                key={index}
                                onMouseDown={(e) => {
                                  e.preventDefault(); // Prevent editor blur
                                  insertMention(
                                    mentionType === "UserMention"
                                      ? item?.entityName
                                      : item?.hashTag,
                                    mentionType === "UserMention"
                                      ? item?.userUid
                                      : null
                                  );
                                }}
                                className="suggestion-item"
                              >
                                {mentionType === "UserMention" ? (
                                  <>
                                    <img
                                      src={item?.avatar}
                                      alt={item?.entityName}
                                      className="avatar"
                                    />
                                    <span>{item?.entityName}</span>
                                  </>
                                ) : (
                                  <span>#{item?.hashTag}</span>
                                )}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>

                    <div className="m-3 d-flex align-items-center">
                      <form className="form" action="#" method="post" id="form">

                      </form>

                    </div>

                    <div
                      className="card-body d-flex flex-wrap justify-content-start"
                      id="container"
                    >
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center mt-4">
                <div className="ImgAvatar">
                  <img
                    src={singlepostList?.postInfo?.postInfo?.userAvatar}
                    alt=""
                    style={{ borderRadius: "50px" }}
                  />
                </div>

                <div className="ms-2">
                  <h4 className="f-14 fw-bold mb-0">{singlepostList?.postInfo?.postInfo?.userName} </h4>
                  <p className="f-12">{singlepostList?.postInfo?.postInfo?.title}</p>
                  <p className="f-12">{singlepostList?.postInfo?.postInfo?.additionalInfo}</p>
                  <p className="f-10 label">
                    {moment
                      .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                      .local()
                      .format("DD MMMM YYYY [at] h:mm a")}
                  </p>
                </div>
              </div>
              {/* </Link> */}
              <PostComponent item={singlepostList} />
              <div
                className="feed-post"
                style={{
                  paddingTop: singlepostList?.postInfo?.postInfo?.postMediaCount === 0 ? "60px" : "4px",
                }}
              >
                <div className="row">
                  {singlepostList?.postInfo?.postInfo?.mediaFilesList?.slice(0, 4)?.map((file, idx) => (
                    <div
                      key={idx}
                      className={`col-${singlepostList?.postInfo?.postInfo?.mediaFilesList.length === 1 ? "12" : "6"
                        } ${singlepostList?.postInfo?.postInfo?.mediaFilesList.length === 3 && idx === 0
                          ? "col-12"
                          : ""
                        }`}
                      onClick={() => {
                        setInitialSlideIndex(idx);
                        setImageArray(singlepostList?.postInfo?.postInfo?.mediaFilesList);
                        console.warn("===========1============>>", idx);
                        let imageData = singlepostList?.postInfo?.postInfo?.mediaFilesList.map(
                          (file) => file.mediaName
                        );
                        openModal(imageData, idx);
                        setSinglePostContent(singlepostList);
                        setSinglePostId(singlepostList?.postInfo?.postInfo?.postId);
                      }}
                      style={{
                        position: "relative",
                        padding:
                          singlepostList?.postInfo?.postInfo?.mediaFilesList.length === 3 && idx === 0
                            ? "0 0 5px 0"
                            : singlepostList?.postInfo?.postInfo?.mediaFilesList.length === 3 && idx === 1
                              ? "0 5px 5px 0"
                              : singlepostList?.postInfo?.postInfo?.mediaFilesList.length === 4 && idx === 2
                                ? "0 5px 0 0"
                                : singlepostList?.postInfo?.postInfo?.mediaFilesList.length === 4 && idx === 0
                                  ? "0 5px 5px 0"
                                  : singlepostList?.postInfo?.postInfo?.mediaFilesList.length === 2 && idx === 0
                                    ? "0 5px 5px 0"
                                    : "",
                      }}
                    >
                      <img
                        src={file.mediaName}
                        alt=""
                        className="img-fluid"
                        width={"100%"}
                      />
                      {idx === 3 && singlepostList?.postInfo?.postInfo?.postMediaCount > 4 && (
                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                          +{singlepostList?.postInfo?.postInfo?.postMediaCount - 4}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                {guestModeData === "true" ? (
                  ""
                ) : (
                  <div className="row comment-gradient">
                    <div
                      className="addComment"
                      onClick={() => {
                        setInitialSlideIndex(1);
                        setImageArray(singlepostList?.postInfo?.postInfo?.mediaFilesList);
                        let imageData = singlepostList?.postInfo?.postInfo?.mediaFilesList.map(
                          (file) => file.mediaName
                        );
                        openModal(imageData, 1);
                        setSinglePostContent(singlepostList?.postInfo);
                        setSinglePostId(singlepostList?.postInfo?.postInfo?.postId);
                      }}
                    >

                    </div>
                  </div>
                )}
              </div>

              <button
                className="mainBtn ms-auto"
                disabled={isloading}
                onClick={handleSubmit}
              >
                {isloading === true ? `${t("Newsfeed.Sharing")}` : `${t("Newsfeed.Share")}`}
              </button>
            </div>
          </div>
        </div>
      )}


      {/* <Modal
        isOpen={shareModal}
        toggle={() => setShareModal(!shareModal)}
        className='modal-dialog-centered upload-postModal'
      >
        <Modal.Header className='bg-transparent p-2 border-bottom' toggle={() => setShareModal(!shareModal)}>
          <h5 className='main-heading'>Share Job</h5>
        </Modal.Header>
        <Modal.Body className='mx-50 pb-2'>
          <FacebookShareButton url={shareUrl} onClick={() => { setShareModal(false) }}>
            <FacebookIcon size={40} />
          </FacebookShareButton>
          <WhatsappShareButton url={shareUrl} className='ms-2' onClick={() => { setShareModal(false) }}>
            <WhatsappIcon size={40} />
          </WhatsappShareButton>
          <LinkedinShareButton url={shareUrl} className='ms-2' onClick={() => { setShareModal(false) }}>
            <LinkedinIcon size={40} />
          </LinkedinShareButton>
          <TwitterShareButton url={shareUrl} className='ms-2' onClick={() => { setShareModal(false) }}>
            <TwitterIcon size={40} />
          </TwitterShareButton>
          <Row>
            <Col className='mt-1 d-flex justify-content-between' xs={2} lg={2}>
            </Col>
            <Col className='mt-1 d-flex justify-content-between' xs={2} lg={2}>
            </Col>
          </Row>
        </Modal.Body>
      </Modal> */}
      {followModal && <ModalForGuest closeModalData={closeModalData} />}
    </>
  );
};

export default SinglePostEngagement;
